import React from 'react';

const HomieContext = React.createContext();

export default HomieContext;
